import { Button } from "antd";
import type { ButtonProps } from "antd";
import { CloudOutlined } from "@ant-design/icons";

type GcloudLinkButtonProps = {
  href: string;
  children: React.ReactNode;
} & Pick<ButtonProps, "type" | "size" | "icon" | "disabled">;

// Opens a Google Cloud console link (logs, traces, ...) in a new tab.
export const GcloudLinkButton: React.FC<GcloudLinkButtonProps> = ({
  href,
  children,
  icon = <CloudOutlined />,
  ...rest
}) => (
  <Button href={href} target="_blank" rel="noreferrer" icon={icon} {...rest}>
    {children}
  </Button>
);
